import { render, staticRenderFns } from "./LiteratureTableRow.vue?vue&type=template&id=8a67c504&scoped=true&"
import script from "./LiteratureTableRow.vue?vue&type=script&lang=js&"
export * from "./LiteratureTableRow.vue?vue&type=script&lang=js&"
import style0 from "./LiteratureTableRow.vue?vue&type=style&index=0&id=8a67c504&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a67c504",
  null
  
)

export default component.exports